import { render, staticRenderFns } from "./ViewExternal.vue?vue&type=template&id=4f67aac5&scoped=true"
import script from "./ViewExternal.vue?vue&type=script&lang=js"
export * from "./ViewExternal.vue?vue&type=script&lang=js"
import style0 from "./ViewExternal.vue?vue&type=style&index=0&id=4f67aac5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f67aac5",
  null
  
)

export default component.exports